var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemitAdvice16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 7H4.25V8H7.25V7Z",
    fill: "#2767A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 3H4.25V4H10.25V3Z",
    fill: "#2767A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 5H4.25V6H10.25V5Z",
    fill: "#2767A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 12H4.25V13H7.25V12Z",
    fill: "#2767A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15H3.25C2.98487 14.9997 2.73068 14.8943 2.5432 14.7068C2.35572 14.5193 2.25028 14.2651 2.25 14V2C2.25028 1.73487 2.35572 1.48068 2.5432 1.2932C2.73068 1.10572 2.98487 1.00028 3.25 1H11.25C11.5151 1.00028 11.7693 1.10572 11.9568 1.2932C12.1443 1.48068 12.2497 1.73487 12.25 2V6.5H11.25V2H3.25V14H8.25V15Z",
    fill: "#2767A9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9H12.25V8H11.25V9H10.75C10.1977 9 9.75 9.4477 9.75 10V11C9.75 11.5523 10.1977 12 10.75 12H12.75V13H9.75V14H11.25V15H12.25V14H12.75C13.3023 14 13.75 13.5523 13.75 13V12C13.75 11.4477 13.3023 11 12.75 11H10.75V10H13.75V9Z",
    fill: "#2767A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemitAdvice16);
export default __webpack_public_path__ + "static/media/RemitAdvice16.3b1e089d9668f732bac9713bf438f358.svg";
export { ForwardRef as ReactComponent };